export default __webpack_public_path__ + "546b4809e90728a64a4f91e399a1e6f4.woff";